import * as swcHelpers from '@swc/helpers';
import { ProductRecommendationAction, BannerRecommendationAction } from '../types.js';
import { createResponsiveImage } from './create-responsive-image.js';

const convertBannerRecommendationInfo = (recommendation)=>{
    const responsiveImage = createResponsiveImage(recommendation.image.url, recommendation.title);
    var _action;
    const action = getBannerRecommendationAction((_action = recommendation.action) !== null && _action !== void 0 ? _action : undefined);
    const link = recommendation.action && action === BannerRecommendationAction.Link && 'link' in recommendation.action && recommendation.action.link;
    const discountCode = recommendation.action && action === BannerRecommendationAction.DiscountCode && 'discountCode' in recommendation.action && recommendation.action.discountCode;
    return swcHelpers.objectSpread({
        title: recommendation.title,
        description: recommendation.description,
        image: {
            url: responsiveImage.url,
            mobileUrl: responsiveImage.url,
            description: recommendation.description
        },
        action
    }, link && {
        link
    }, discountCode && {
        discountCode
    });
};
const getProductRecommendationAction = (action)=>{
    if (!action) {
        return;
    }
    if ('hasQuantitySelector' in action && 'sku' in action) {
        return action.hasQuantitySelector ? ProductRecommendationAction.AddQuantity : ProductRecommendationAction.AddToCart;
    }
    if ('slug' in action) {
        return ProductRecommendationAction.Redirect;
    }
};
const getBannerRecommendationAction = (action)=>{
    if (!action) {
        return;
    }
    if ('link' in action) {
        return BannerRecommendationAction.Link;
    }
    if ('discountCode' in action) {
        return BannerRecommendationAction.DiscountCode;
    }
};

export { convertBannerRecommendationInfo, getProductRecommendationAction };
//# sourceMappingURL=mappers.js.map
